import { Box, Breadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
// Icons
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { colors } from "../../theme/designTokens";
import { useLangPath } from "../../hooks/langAlias";

export default function BreadcrumbsTemplate({ b2, l2, b3 }) {
  const lp = useLangPath();
  return (
    <Box sx={{ borderBottom: `1px solid ${colors.line}` }}>
      <Box sx={{ maxWidth: 1400, mx: "auto", px: { xs: 2, sm: 3, md: 5 }, py: 1.5 }}>
        <Breadcrumbs
          separator={<ChevronRightRoundedIcon sx={{ fontSize: 18, color: colors.ink3 }} />}
          aria-label="breadcrumb"
        >
          <Link
            to={lp("/")}
            style={{
              display: "flex",
              alignItems: "center",
              color: colors.ink3,
              textDecoration: "none",
            }}
          >
            <HomeRoundedIcon sx={{ fontSize: 18 }} />
          </Link>
          {b2 && l2 && (
            <Link
              to={lp(l2)}
              style={{
                color: colors.ink2,
                fontSize: 13.5,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              {b2}
            </Link>
          )}
          <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: colors.ink }}>
            {b3}
          </Typography>
        </Breadcrumbs>
      </Box>
    </Box>
  );
}
